import { type IEntitiesStore } from 'entities/EntitiesExport'

export const logV2SearchEvent = async (
  eventName: string,
  payload: Record<string, string>,
  entities: IEntitiesStore
) => {
  await Promise.all([entities.usersStore.initPromise, entities.organizationStore.initPromise])

  entities.eventLogStore.logEvent(
    eventName,
    {
      ...payload,
      agencyId: entities.organizationStore.agency_id,
    },
    { groupId: entities.organizationStore.id }
  )
}
